
import { defineComponent } from 'vue'
import { version } from "../../../package.json";
import LogoElem from "../pageElements/LogoElem.vue";

export default defineComponent({
    name: "MainSection",

    components:{
        LogoElem
    },

    data(){
        return{
            appVersion: version
        }
    },

    methods:{

        logoScroll(){
    
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });

        }
        
    }

});
